import type { IArea } from './types';

export const AREAS_MAPPING: {
  [key: string]: IArea;
} = {
  GLOBAL: 'global',
  NORTH_AMERICA: 'us/canada',
  EUROPE: 'europe',
};

export const AREAS_NAMES_MAPPING: {
  [key: string]: string;
} = {
  [AREAS_MAPPING.GLOBAL]: 'dbi_global',
  [AREAS_MAPPING.NORTH_AMERICA]: 'dbi_area_north_america',
  [AREAS_MAPPING.EUROPE]: 'dbi_area_europe',
};

export const AREAS: IArea[] = [AREAS_MAPPING.GLOBAL, AREAS_MAPPING.NORTH_AMERICA, AREAS_MAPPING.EUROPE];

export const AREAS_NO_GLOBAL: IArea[] = [AREAS_MAPPING.NORTH_AMERICA, AREAS_MAPPING.EUROPE];
